import { render, staticRenderFns } from "./playerManage.vue?vue&type=template&id=1d4d5b58&scoped=true&"
import script from "./playerManage.vue?vue&type=script&lang=ts&"
export * from "./playerManage.vue?vue&type=script&lang=ts&"
import style0 from "./playerManage.vue?vue&type=style&index=0&id=1d4d5b58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4d5b58",
  null
  
)

export default component.exports